import GSAP from 'gsap'

import Animation from 'classes/Animation'

import Splitting from 'splitting'

export default class SmallTitle extends Animation {
  constructor ({ element, elements }) {
    super({
      element,
      elements
    })

    Splitting({ target: this.element, by: 'chars' })

    this.titleLinesSpans = this.element.querySelectorAll('span')

    this.onResize()

    this.tl = GSAP.timeline({ delay: 0.5 })
  }

  animateIn () {
    this.tl.fromTo(this.titleLinesSpans, {
      autoAlpha: 0,
      y: '20px'
    }, {
      autoAlpha: 1,
      stagger: {
        axis: 'x',
        amount: 0.7
      },
      rotation: 0.01,
      duration: 1.5,
      ease: 'power4.out',
      y: 0
    })
  }

  animateOut () {
  }

  onResize () {
    // this.titleLines = calculate(this.titleLinesSpans)
  }
}
